<footer class="container py-4" role="contentinfo">
	<div class="footer-links-wrapper d-flex flex-wrap justify-content-md-end">
		<div class="mobile-border container"></div>
		<div class="footer-statement" data-cy="footer-copyright">
			&copy;{{ copyrightYear }} EdAssist by Bright Horizons. All Rights Reserved.
		</div>
		<ea-bh-logo class="bh-logo"></ea-bh-logo>
		@if (showSiteMap) {
			<ea-anchor
				[href]="'/tuition/site-map'"
				[isRouterLink]="false"
				id="siteMapLink"
				data-cy="footer-site-map"
				class="d-block text-center text-md-left">
				Site Map
			</ea-anchor>
		}
		@for (link of links; track link) {
			<ea-anchor
				[href]="link.href"
				[isRouterLink]="false"
				[target]="'_blank'"
				[id]="link.id"
				[attr.data-cy]="link.dataCy"
				class="d-block text-center text-md-left">
				{{ link.text }} <i class="fa fa-external-link" aria-hidden="true"></i>
			</ea-anchor>
		}
	</div>
	<!-- todo remove space in span driving pendo button and setup placement in pendo portal -->
	<div class="pendo-wrapper margin-top-4" id="copyright" data-cy="footer-copyright">
		<span>&nbsp;</span>
	</div>
</footer>